/**
 * @file: FrameListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import ListModel from './ReportListModel';
import {toLower, assign} from 'lodash';
import uri from '@baidu/ve-ria/utils/uri';

export default class Model extends ListModel {
    pageType = '卡片';

    init() {
        super.init();

        if (this.pageType === '中间页') {
            // 默认是父类中的CARD_STATUS，子类继承时如果是中间页覆盖下。
            this.cardStatusMap = this.getConstantMap('FRAME_STATUS');
        }
    }

    adaptData(data) {
        data.result.forEach(item => {
            item.statusLabel = this.cardStatusMap[item.status];
            item.statusColor = toLower(item.status);
            item.clickRatioPercent = this.toPercentText(item.clickRatio);
        });
        return data;
    }

    getDetailUrl(params) {
        return uri.withQuery(
            '/stats/material/report/component',
            assign(params, this.pickParamsWithDate('aderId'))
        );
    }
}
